export default "__VITE_ASSET__DGg7uwiX__"